interface IProps {
    text: string | JSX.Element
}

export const BlankLine: React.FC<IProps> = ({text}) => {
    return (
        <span style={{verticalAlign:'sub'}}> {text} </span>
    )
}